import React, { useState, useEffect } from 'react';

function PrivacyPolicy() {
  const [activeSection, setActiveSection] = useState('');

  const sections = [
    { id: 'introduction', title: 'Giriş', icon: 'info' },
    { id: 'data-collection', title: 'Məlumatların Toplanması', icon: 'database' },
    { id: 'data-usage', title: 'Məlumatların İstifadəsi', icon: 'settings' },
    { id: 'data-storage', title: 'Məlumatların Saxlanması', icon: 'shield' },
    { id: 'cookies', title: 'Çərəzlər (Cookies)', icon: 'cookie' },
    { id: 'user-rights', title: 'İstifadəçi Hüquqları', icon: 'user' },
    { id: 'data-sharing', title: 'Məlumatların Paylaşılması', icon: 'share' },
    { id: 'security', title: 'Təhlükəsizlik', icon: 'lock' },
    { id: 'changes', title: 'Dəyişikliklər', icon: 'edit' },
    { id: 'elaqe', title: 'Əlaqə', icon: 'mail' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 150;

      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const getIcon = (iconName) => {
    const icons = {
      info: <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>,
      database: <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v2.5C4 13.71 7.58 15.5 12 15.5s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 4.5V16c0 2.21 3.58 4 8 4s8-1.79 8-4v-2.5c0 2.21-3.58 4-8 4s-8-1.79-8-4z"/>,
      settings: <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>,
      shield: <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>,
      cookie: <circle cx="12" cy="12" r="10"/>,
      user: <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>,
      share: <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>,
      lock: <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>,
      edit: <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>,
      mail: <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
    };
    return icons[iconName] || icons.info;
  };

  return (
    <div className="privacy_page_wrapper">
      <div className="privacy_container_main">
        <div className="privacy_hero_section">
          <div className="privacy_hero_icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
            </svg>
          </div>
          <h1 className="privacy_main_title">Məxfilik Siyasəti</h1>
          <p className="privacy_main_description">Şəxsi məlumatlarınızın qorunması bizim üçün prioritetdir</p>
          <div className="privacy_last_update">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            <span>Son yenilənmə: 15 Oktyabr 2024</span>
          </div>
        </div>

        <div className="privacy_content_layout">
          <aside className="privacy_sidebar_nav">
            <div className="privacy_sidebar_sticky">
              <h3 className="privacy_sidebar_title">Mündəricat</h3>
              <nav className="privacy_toc_nav">
                {sections.map((section) => (
                  <button
                    key={section.id}
                    className={`privacy_toc_item ${activeSection === section.id ? 'privacy_toc_active' : ''}`}
                    onClick={() => scrollToSection(section.id)}
                  >
                    <svg className="privacy_toc_icon" viewBox="0 0 24 24" fill="currentColor">
                      {getIcon(section.icon)}
                    </svg>
                    <span>{section.title}</span>
                  </button>
                ))}
              </nav>
            </div>
          </aside>

          <main className="privacy_main_content">
            {/* Introduction */}
            <section id="introduction" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('info')}
                  </svg>
                </div>
                <h2>Giriş</h2>
              </div>
              <div className="privacy_section_content">
                <p>
                  herracim.az olaraq istifadəçilərimizin məxfiliyinə böyük əhəmiyyət veririk. 
                  Bu məxfilik siyasəti platformamızdan istifadə zamanı hansı məlumatların toplandığını, 
                  necə istifadə olunduğunu və necə qorunduğunu izah edir.
                </p>
                <div className="privacy_info_box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="16" x2="12" y2="12"/>
                    <line x1="12" y1="8" x2="12.01" y2="8"/>
                  </svg>
                  <div>
                    <strong>Vacib qeyd:</strong>
                    <p>Platformamızdan istifadə etməklə bu məxfilik siyasətinə razılıq vermiş olursunuz.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Data Collection */}
            <section id="data-collection" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('database')}
                  </svg>
                </div>
                <h2>Məlumatların Toplanması</h2>
              </div>
              <div className="privacy_section_content">
                <p>Platformamızdan istifadə zamanı sizdən aşağıdakı məlumatlar toplanır:</p>
                <div className="privacy_data_grid">
                  <div className="privacy_data_card">
                    <h4>Şəxsi Məlumatlar</h4>
                    <ul>
                      <li>Ad və Soyad</li>
                      <li>Email ünvanı</li>
                      <li>Telefon nömrəsi</li>
                      <li>Ünvan (çatdırılma üçün)</li>
                    </ul>
                  </div>
                  <div className="privacy_data_card">
                    <h4>Hesab Məlumatları</h4>
                    <ul>
                      <li>İstifadəçi adı</li>
                      <li>Şifrə (şifrələnmiş)</li>
                      <li>Profil şəkli</li>
                      <li>Doğum tarixi</li>
                    </ul>
                  </div>
                  <div className="privacy_data_card">
                    <h4>Texniki Məlumatlar</h4>
                    <ul>
                      <li>IP ünvanı</li>
                      <li>Brauzer məlumatları</li>
                      <li>Cihaz növü</li>
                      <li>Giriş tarixçəsi</li>
                    </ul>
                  </div>
                  <div className="privacy_data_card">
                    <h4>Əməliyyat Məlumatları</h4>
                    <ul>
                      <li>Hərrac tarixçəsi</li>
                      <li>Ödəniş məlumatları</li>
                      <li>Depozit əməliyyatları</li>
                      <li>Mesajlaşma tarixçəsi</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Data Usage */}
            <section id="data-usage" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('settings')}
                  </svg>
                </div>
                <h2>Məlumatların İstifadəsi</h2>
              </div>
              <div className="privacy_section_content">
                <p>Toplanan məlumatlar aşağıdakı məqsədlər üçün istifadə olunur:</p>
                <div className="privacy_usage_list">
                  <div className="privacy_usage_item">
                    <div className="privacy_usage_number">1</div>
                    <div>
                      <h4>Xidmətin Göstərilməsi</h4>
                      <p>Hesabınızın idarə edilməsi, hərraclarda iştirakınız və əməliyyatların həyata keçirilməsi</p>
                    </div>
                  </div>
                  <div className="privacy_usage_item">
                    <div className="privacy_usage_number">2</div>
                    <div>
                      <h4>Təhlükəsizliyin Təmin Edilməsi</h4>
                      <p>Fırıldaqçılığın qarşısının alınması və platformanın təhlükəsizliyinin təmin edilməsi</p>
                    </div>
                  </div>
                  <div className="privacy_usage_item">
                    <div className="privacy_usage_number">3</div>
                    <div>
                      <h4>Ünsiyyət</h4>
                      <p>Sizinlə əlaqə saxlanması, bildirişlərin göndərilməsi və müştəri xidmətinin göstərilməsi</p>
                    </div>
                  </div>
                  <div className="privacy_usage_item">
                    <div className="privacy_usage_number">4</div>
                    <div>
                      <h4>Təkmilləşdirmə</h4>
                      <p>Platformanın təcrübəsinin yaxşılaşdırılması və yeni xüsusiyyətlərin əlavə edilməsi</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Data Storage */}
            <section id="data-storage" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('shield')}
                  </svg>
                </div>
                <h2>Məlumatların Saxlanması və Qorunması</h2>
              </div>
              <div className="privacy_section_content">
                <p>
                  Toplanan bütün məlumatlar təhlükəsiz serverlərdə saxlanılır və müasir 
                  şifrələmə texnologiyaları ilə qorunur.
                </p>
                <div className="privacy_security_features">
                  <div className="privacy_feature_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                    <h4>SSL Şifrələmə</h4>
                    <p>Bütün məlumat ötürülməsi SSL ilə qorunur</p>
                  </div>
                  <div className="privacy_feature_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M12 6v6l4 2"/>
                    </svg>
                    <h4>24/7 Monitorinq</h4>
                    <p>Sistemlər daim izlənir və qorunur</p>
                  </div>
                  <div className="privacy_feature_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                    <h4>Məhdud Giriş</h4>
                    <p>Yalnız səlahiyyətli personal girişi var</p>
                  </div>
                  <div className="privacy_feature_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                    </svg>
                    <h4>Yedəkləmə</h4>
                    <p>Gündəlik avtomatik ehtiyat nüsxələri</p>
                  </div>
                </div>
                <div className="privacy_warning_box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                  <div>
                    <strong>Qeyd:</strong>
                    <p>Məlumatlarınız heç bir halda üçüncü şəxslərlə kommersiya məqsədilə paylaşılmır.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Cookies */}
            <section id="cookies" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('cookie')}
                  </svg>
                </div>
                <h2>Çərəzlər (Cookies)</h2>
              </div>
              <div className="privacy_section_content">
                <p>
                  Saytın düzgün işləməsi və istifadə təcrübəsinin yaxşılaşdırılması məqsədilə 
                  çərəzlərdən istifadə olunur.
                </p>
                <div className="privacy_cookie_types">
                  <div className="privacy_cookie_type">
                    <h4>Zəruri Çərəzlər</h4>
                    <span className="privacy_cookie_badge privacy_badge_required">Məcburi</span>
                    <p>Saytın əsas funksiyalarının işləməsi üçün zəruridir</p>
                  </div>
                  <div className="privacy_cookie_type">
                    <h4>Funksional Çərəzlər</h4>
                    <span className="privacy_cookie_badge privacy_badge_optional">İstəyə görə</span>
                    <p>Təcrübənizi fərdiləşdirmək və əvvəlki seçimlərinizi yadda saxlamaq üçün</p>
                  </div>
                  <div className="privacy_cookie_type">
                    <h4>Analitik Çərəzlər</h4>
                    <span className="privacy_cookie_badge privacy_badge_optional">İstəyə görə</span>
                    <p>Saytın istifadəsini başa düşmək və təkmilləşdirmək üçün</p>
                  </div>
                </div>
                <p className="privacy_cookie_note">
                  Brauzerinizin parametrlərindən çərəzləri idarə edə bilərsiniz.
                </p>
              </div>
            </section>

            {/* User Rights */}
            <section id="user-rights" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('user')}
                  </svg>
                </div>
                <h2>İstifadəçi Hüquqları</h2>
              </div>
              <div className="privacy_section_content">
                <p>Şəxsi məlumatlarınızla bağlı aşağıdakı hüquqlara sahibsiniz:</p>
                <div className="privacy_rights_grid">
                  <div className="privacy_right_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    <h4>Giriş Hüququ</h4>
                    <p>Haqqınızda saxladığımız məlumatları görmək hüququ</p>
                  </div>
                  <div className="privacy_right_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                    <h4>Düzəliş Hüququ</h4>
                    <p>Məlumatlarınızı yeniləmək və düzəltmək hüququ</p>
                  </div>
                  <div className="privacy_right_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="3 6 5 6 21 6"/>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    </svg>
                    <h4>Silinmə Hüququ</h4>
                    <p>Məlumatlarınızın silinməsini tələb etmək hüququ</p>
                  </div>
                  <div className="privacy_right_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                      <line x1="9" y1="9" x2="15" y2="15"/>
                      <line x1="15" y1="9" x2="9" y2="15"/>
                    </svg>
                    <h4>Etiraz Hüququ</h4>
                    <p>Məlumatlarınızın işlənməsinə etiraz etmək hüququ</p>
                  </div>
                </div>
                <div className="privacy_rights_action">
                  <p>Bu hüquqlarınızdan istifadə etmək üçün bizimlə əlaqə saxlayın:</p>
                  <a href="mailto:privacy@herrac.com" className="privacy_elaqe_email">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                    privacy@herrac.com
                  </a>
                </div>
              </div>
            </section>

            {/* Data Sharing */}
            <section id="data-sharing" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('share')}
                  </svg>
                </div>
                <h2>Məlumatların Tərəfdaşlarla Paylaşılması</h2>
              </div>
              <div className="privacy_section_content">
                <p>
                  Şəxsi məlumatlarınız heç bir halda üçüncü tərəflərlə kommersiya məqsədilə paylaşılmır. 
                  Yalnız aşağıdakı hallarda minimum səviyyədə paylaşılır:
                </p>
                <div className="privacy_sharing_cases">
                  <div className="privacy_case_item">
                    <div className="privacy_case_icon">✓</div>
                    <div>
                      <h4>Ödəniş Prosessorları</h4>
                      <p>Ödənişlərin təhlükəsiz şəkildə həyata keçirilməsi üçün</p>
                    </div>
                  </div>
                  <div className="privacy_case_item">
                    <div className="privacy_case_icon">✓</div>
                    <div>
                      <h4>Texniki Xidmət Təminatçıları</h4>
                      <p>Serverlərin və infrastrukturun idarə edilməsi üçün</p>
                    </div>
                  </div>
                  <div className="privacy_case_item">
                    <div className="privacy_case_icon">✓</div>
                    <div>
                      <h4>Hüquqi Tələblər</h4>
                      <p>Qanunvericiliyə uyğun olaraq aidiyyəti qurumlara</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Security */}
            <section id="security" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('lock')}
                  </svg>
                </div>
                <h2>Təhlükəsizlik Tədbirləri</h2>
              </div>
              <div className="privacy_section_content">
                <p>Məlumatlarınızın təhlükəsizliyini təmin etmək üçün aşağıdakı tədbirlər görülür:</p>
                <ul className="privacy_security_list">
                  <li>256-bit SSL şifrələməsi ilə bütün məlumat ötürülməsi</li>
                  <li>Şifrələrin güclü hash alqoritmləri ilə saxlanması</li>
                  <li>İki faktorlu autentifikasiya (2FA) dəstəyi</li>
                  <li>Müntəzəm təhlükəsizlik auditləri və penetrasiya testləri</li>
                  <li>DDoS hücumlarına qarşı qoruma</li>
                  <li>Məlumat itkisinin qarşısını almaq üçün gündəlik ehtiyat nüsxələr</li>
                  <li>Təhlükəsizlik hadisələrinin real vaxt izlənməsi</li>
                </ul>
              </div>
            </section>

            {/* Changes */}
            <section id="changes" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('edit')}
                  </svg>
                </div>
                <h2>Siyasətdə Dəyişikliklər</h2>
              </div>
              <div className="privacy_section_content">
                <p>
                  Bu məxfilik siyasəti vaxtaşırı yenilənə bilər. Əhəmiyyətli dəyişikliklər olduqda 
                  email vasitəsilə və ya platformada bildiriş göndərməklə sizi məlumatlandıracağıq.
                </p>
                <div className="privacy_info_box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="16" x2="12" y2="12"/>
                    <line x1="12" y1="8" x2="12.01" y2="8"/>
                  </svg>
                  <div>
                    <strong>Məsləhət:</strong>
                    <p>Dəyişikliklərdən xəbərdar olmaq üçün bu səhifəni müntəzəm yoxlayın.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* elaqe */}
            <section id="elaqe" className="privacy_section_block">
              <div className="privacy_section_header">
                <div className="privacy_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('mail')}
                  </svg>
                </div>
                <h2>Bizimlə Əlaqə</h2>
              </div>
              <div className="privacy_section_content">
                <p>
                  Məxfilik siyasətimizlə bağlı suallarınız və ya narahatlıqlarınız varsa, 
                  bizimlə əlaqə saxlamaqdan çəkinməyin:
                </p>
                <div className="privacy_elaqe_info_grid">
                  <div className="privacy_elaqe_info_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                    <h4>Email</h4>
                    <a href="mailto:privacy@herrac.com">privacy@herrac.com</a>
                  </div>
                  <div className="privacy_elaqe_info_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                    <h4>Telefon</h4>
                    <a href="tel:+994501112233">+994 50 111 22 33</a>
                  </div>
                </div>
              </div>
            </section>

            <div className="privacy_final_note">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <p>
                <strong>Saytdan istifadə etməklə bu məxfilik siyasətinə razılıq vermiş sayılırsınız.</strong>
              </p>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;